"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var platformCardApi = _interopRequireWildcard(require("@/api/platformCardApi.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      loading: false,
      productLists: [],
      form: {},
      rules: {
        skuId: [{
          required: true,
          message: '请选择对应商品',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit() {
      var _this = this;
      this.form = {
        remark: ''
      };
      this.visible = true;
      this.searchProduct('');
      this.$nextTick(function () {
        return _this.$refs.form && _this.$refs.form.clearValidate();
      });
    },
    searchProduct: function searchProduct() {
      var _this2 = this;
      var skuName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      platformCardApi.getProductSkuList({
        type: 0,
        productType: 12,
        page: 1,
        limit: 50,
        skuName: skuName
      }).then(function (res) {
        _this2.productLists = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
    },
    handleProductSearch: function handleProductSearch(value) {
      var _this3 = this;
      this.throttle(function () {
        return _this3.searchProduct(value);
      }, 300)();
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this4.loading = true;
        platformCardApi.saveCardConfig({
          skuId: _this4.form.skuId,
          remark: _this4.form.remark
        }).then(function () {
          _this4.$message.success('操作成功');
          _this4.visible = false;
          _this4.$emit('doRefresh');
        }).finally(function () {
          _this4.loading = false;
        });
      });
    }
  }
};